<template>
    <el-aside :style="{'width':menuIsCollapse?'64px':'200px'}" class="asideNav sider">
        <nav>
            <div class="logo" :style="{'margin-right':menuIsCollapse?'22px':'15px'}">
                <!-- <icon-svg iconClass="expend" @click.native="changeCollapse"></icon-svg> -->
                <!-- <icon-svg iconClass="expend"></icon-svg> -->
                <div class="el-icon-sort inside" @click="changeCollapse"></div>
            </div>
            <el-menu class="el-menu-vertical-demo sider" :style="{'width':menuIsCollapse?'64px':'200px'}" :collapse="menuIsCollapse" default-active="1"
                  :unique-opened='false' @open="handleOpen" @close="handleClose"
                background-color="#545c64" text-color="#fff" active-text-color="#ffd04b"
                :default-openeds="dfo">
                <el-submenu index="1" v-if="power('WPTMGR')">
                    <template slot="title">
                        <i class="el-icon-setting"></i>
                        <span>平台管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/Home/SystemS',name: '系统管理工作台'})"
                            v-if="power('WPTMGR_SYSMGR')" index="1-1">
                            系统管理工作台
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/Home/SystemBase',name: '基础管理工作台'})"
                            v-if="power('WPTMGR_BASEMGR')" index="1-2">
                            基础管理工作台
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/Home/ruleBase',name: '规则配置'})"
                            v-if="power('TALLY_ACCOUNTUNIT_COMPARE')"
                            index="4-8">
                            规则配置
                        </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                <!-- </el-submenu> -->

                <el-submenu index="2" v-if="power('WBUSMGR')">
                    <template slot="title">
                        <i class="el-icon-goods"></i>
                        <span>商务管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/business/busPla',name: '商务管理'})"
                            v-if="power('WBUSMGR_BUSMGR')" index="2-1">
                            商务管理工作台
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>

                <el-submenu index="3" v-if="power('WJOB')">
                    <template slot="title">
                        <i class="el-icon-document"></i>
                        <span>集装箱现场作业</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/gatePanel',name: '铁路道闸工作台'})"
                            v-if="power('WJOB_TRAIN')" index="3-2">
                            铁路道闸工作台
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/JobPlan',name: '铁路作业计划管理'})"
                            v-if="power('WJOB_CONTAINERPLAN')" index="3-3">
                            铁路作业计划管理
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/containerJob',name: '铁路集装箱作业台'})"
                            v-if="power('WJOB_CONTAINERPLANJOB')" index="3-4">
                            铁路集装箱作业台
                        </el-menu-item>
                    </el-menu-item-group>
                    <!--629 二期代码屏蔽-->
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/yardPlan',name: '堆场策划管理'})"
                            v-if="power('WJOB_YARDPLAN')" index="3-5">
                            堆场策划管理
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/middleControl',name: '中控调度'})"
                            v-if="power('WJOB_CONTROL_CONTAINER')" index="3-6">
                            中控调度
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/gate',name: '闸口管理'})"
                            v-if="power('WJOB_GATE_CONTAINER')" index="3-7">
                            闸口管理
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/portCount',name: '港口总览'})"
                            v-if="power('WSTATISTICS_PORTOVERVIEW')" index="3-8">
                            港口总览
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/piece',name: '作业计件'})"
                            v-if="power('WSTATISTICS_PORTOVERVIEW')" index="3-9">
                            作业计件
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>

                <el-submenu index="5" v-if="power('TOS_CUSTOMER')">
                    <template slot="title">
                        <i class="el-icon-goods"></i>
                        <span>集装箱客户应用</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/business/tos',name: '客户委托'})"
                            v-if="power('TOS_CUSTOMER_ARRIVALENTRUST')" index="5-1">
                            铁路到达委托
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <!-- 生产日报 -->
                <el-submenu index="11" v-if="power('WSTATISTICS_PRODAYREPORT')">
                    <template slot="title">
                        <i class="el-icon-goods"></i>
                        <span>生产日报</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/business/tos/reportWzg',name: '生产日报（万州港）'})"
                            v-if="power('WSTATISTICS_PRODAYREPORT_WZG')" index="11-1">
                            生产日报（万州港）
                        </el-menu-item>
                        <el-menu-item @click="handleRouterPush({path: '/business/tos/reportWjs',name: '生产日报（万九司）'})"
                            v-if="power('WSTATISTICS_PRODAYREPORT_WJS')" index="11-2">
                            生产日报（万九司）
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <!--外理-->
                <!--<el-submenu index="4" v-if="power('TALLY')">-->
                <el-submenu index="4" v-if="power('TALLY')">
                    <template slot="title">
                        <i class="el-icon-document"></i>
                        <span>外理系统</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/shipPlan/index',name: '理货作业'})"
                            v-if="power('TALLY_WORK')" index="4-1">
                            理货作业
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/cashIndex',name: '财务结算'})"
                            v-if="power('TALLY_BILL')" index="4-2">
                            财务结算
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/task',name: '作业计件'})"
                            v-if="power('TALLY_PIECE')" index="4-3">
                            作业计件
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/shipPlan/dayReport',name: '理货作业日报'})"
                            v-if="power('TALLY_DAYREPORT')" index="4-4">
                            理货作业日报
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/shipPlan/monthReport',name: '财务月报'})"
                            v-if="power('TALLY_MONTHREPORT')" index="4-5">
                            财务月报
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/shipPlan/productReport',name: '生产作业统计'})"
                            v-if="power('TALLY_PROCESS')" index="4-6">
                            生产作业统计
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/shipPlan/jobTrack',name: '作业跟踪'})"
                            v-if="power('TALLY_JOBTRACK')" index="4-7">
                            作业跟踪
                        </el-menu-item>
                    </el-menu-item-group>
                    
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/liHuoZuoYe/tlzygz',name: '铁路作业.跟踪'})"
                            v-if="power('TALLY_JOBTRACK')" index="4-8">
                            铁路作业跟踪
                        </el-menu-item>
                    </el-menu-item-group>

                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/proofreadBill',name: '月对账单'})"
                            v-if="power('TALLY_PROOFREAD')" index="4-9">
                            月对账单
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/shipPlan/monthAccFeeReport',name: '月度结算统计'})"
                            v-if="power('TALLY_FEE_STATISTICS')" index="4-10">
                            月度结算统计
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/messageQuery',name: '报文查询'})"
                            v-if="power('TALLY_MESSAGE_QUERY')" index="4-11">
                            报文查询
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="6" v-if="power('TALLY_CUSTOMER')">
                    <template slot="title">
                        <i class="el-icon-menu"></i>
                        <span>外理客户应用</span>
                    </template>

                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/query/load',name: '装船查询'})"
                            v-if="power('TALLY_CUSTOMER_ZC')" index="6-1">
                            装船查询
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/query/unload',name: '卸船查询'})"
                            v-if="power('TALLY_CUSTOMER_XC')" index="6-2">
                            卸船查询
                        </el-menu-item>
                    </el-menu-item-group>

                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/query/boxup',name: '装箱查询'})"
                            v-if="power('TALLY_CUSTOMER_BOX')" index="6-3">
                            装箱查询
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/query/unpack',name: '拆箱查询'})"
                            v-if="power('TALLY_CUSTOMER_UNBOX')" index="6-4">
                            拆箱查询
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/query/damaged',name: '残损箱查询'})"
                            v-if="power('TALLY_CUSTOMER_DAMAGED')" index="6-5">
                            残损箱查询
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/query/bill',name: '账单查询'})"
                            v-if="power('TALLY_CUSTOMER_ACCOUNTBILL')" index="6-6">
                            账单查询
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/work/query/special',name: '特殊理箱查询'})"
                            v-if="power('TALLY_CUSTOMER_SPECIAL')" index="6-7">
                            特殊理箱查询
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>

                <el-submenu index="7" v-if="power('WWMS')">
                    <template slot="title">
                        <i class="el-icon-document"></i>
                        <span>仓储系统</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/goods/business',name: '商务管理工作台'})" index="7-1">
                            商务管理工作台
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/goods/storehouse',name: '仓库管理'})" index="7-2">
                            仓库管理平台
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-submenu index="8" v-if="power('WWMS')">
                        <template slot="title">
                            <span>实物/货权管理</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item @click="handleRouterPush({path: '/goods/things',name: '货权管理'})" index="8-1">
                                货权管理
                            </el-menu-item>
                        </el-menu-item-group>
                        <el-menu-item-group>
                            <el-menu-item @click="handleRouterPush({path: '/goods/matter',name: '实物管理工作台'})"
                                index="8-2">
                                实物管理工作台
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu index="9" v-if="power('WWMS')">
                        <template slot="title">
                            <span>接发管理</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item @click="handleRouterPush({path: '/goods/accept',name: '接发管理工作台'})"
                                index="9-1">
                                接发管理工作台
                            </el-menu-item>
                        </el-menu-item-group>
                        <el-menu-item-group>
                            <el-menu-item @click="handleRouterPush({path: '/goods/gate',name: '闸口工作台'})" index="9-2">
                                闸口工作台
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-submenu index="10" v-if="power('WWMS')">
                        <template slot="title">
                            <span>现场作业管理</span>
                        </template>
                        <el-menu-item-group>
                            <el-menu-item @click="handleRouterPush({path: '/goods/enter',name: '入库作业平台'})" index="10-1">
                                入库作业平台
                            </el-menu-item>
                        </el-menu-item-group>
                        <el-menu-item-group>
                            <el-menu-item @click="handleRouterPush({path: '/goods/out',name: '出库作业平台'})" index="10-2">
                                出库作业平台
                            </el-menu-item>
                        </el-menu-item-group>

                        <el-menu-item-group>
                            <el-menu-item @click="handleRouterPush({path: '/goods/raw',name: '原料加工工作台'})" index="10-3">
                                原料加工工作台
                            </el-menu-item>
                        </el-menu-item-group>
                    </el-submenu>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/goods/monitor',name: '中控调度管理'})" index="7-11">
                            中控调度管理
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group  v-if="power('WWMS_REVENUE')">
                        <el-menu-item @click="handleRouterPush({path: '/goods/revenue',name: '营收工作台'})" index="7-12">
                            营收工作台
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group v-if="power('WWMS_PIECES')">
                        <el-menu-item @click="handleRouterPush({path: '/goods/record',name: '作业计件管理平台'})" index="7-14">
                            作业计件管理平台
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item @click="handleRouterPush({path: '/goods/report',name: '统计报表'})" index="7-15">
                            统计报表
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
            </el-menu>
        </nav>
    </el-aside>
</template>

<script>
    export default {
        name: 'navItem',

        data(){
            return {
                dfo:[],
            };
        },

        mounted(){
            console.info("我已重新加载");
            this.dfo=JSON.parse(sessionStorage.getItem("dfo")||"[]");
        },


        computed: {
            menuIsCollapse() {
                return this.$store.getters.menuIsCollapse
            }
        },
        methods: {
            handleOpen(key, keyPath) {
                console.log("打开时",key, keyPath);
                this.dfo.push(key);
                sessionStorage.setItem("dfo",JSON.stringify(this.dfo));
            },
            handleClose(key, keyPath) {
                console.log("关闭时",key, keyPath);
                this.dfo=this.dfo.filter(ele=>{
                    return ele!=key;
                });
                sessionStorage.setItem("dfo",JSON.stringify(this.dfo));
            },
            handleRouterPush(val) {
                this.$store.commit('ADD_CACHED_VIEWS', val)
                this.$router.push(val.path)
            },
            changeCollapse() {
                this.$store.commit('SET_MENU_COLLAPSE', !this.menuIsCollapse)
            }
        }
    }

</script>

<style scoped>
    .asideNav {
        height: 100%;
        position: fixed;
        /* top: 60px; */
        top: 0px;
        bottom: 0;
        left: 0;
        overflow-y: auto;
        background-color: rgb(84, 92, 100);
        z-index: 200;
    }

    .asideNav::-webkit-scrollbar {
        display: none;
    }

    .logo {
        color: #fff;
        text-align: right;
        margin-right: 15px;
    }

    .inside {

        transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        -moz-transform: rotate(90deg);
        -webkit-transform: rotate(90deg);
        -o-transform: rotate(90deg);
    }

    .sider {
        border: none;
        transition: width 0.28s ease-out;
    }

</style>



// WEBPACK FOOTER //
// src/views/layout/navItem.vue